import { render, staticRenderFns } from "./AuctionUpdateForm.vue?vue&type=template&id=4679ce2e"
import script from "./AuctionUpdateForm.vue?vue&type=script&lang=js"
export * from "./AuctionUpdateForm.vue?vue&type=script&lang=js"
import style0 from "./AuctionUpdateForm.vue?vue&type=style&index=0&id=4679ce2e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports